import { InjectionToken } from '@angular/core';

export const ORDERS_LIMIT = new InjectionToken<number>('OrdersLimit');
